import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IReporteVentaCorporativaParams } from '@/shared/interfaces';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadoProspectoEnum,
  hasPermission,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
} from '@/shared';

import { useNavigate } from 'react-router-dom';
import { useColumnsSeguimientoCoste } from './columns/useColumnsSeguimientoCoste';
import { useFetchReporteGeneralCorporativo } from '@/shared/actions/erp/reporte-venta-corporativa.actions';
import InfoCoordendas from '@/shared/components/ui/InfoCoordendas/InfoCoordendas';
import { Timeline, Visibility, Edit } from '@mui/icons-material';
import { useState } from 'react';
import { VerDocumentosHabilitantesContractuales } from '@/erp/supervision-venta-corporativa/solicitudes-pendientes/shared/componente';
import { ModalSolicitudEdicion } from './ModalSolicitudEdicion';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';


interface TableSeguimientoCosteProps {
  showCustomActionBtnSpace?: boolean
  estado_prospecto?: EstadoProspectoEnum
  estado_prospecto_exclude?: EstadoProspectoEnum
}

export default function TableSeguimientoCoste({
  estado_prospecto = undefined,
  estado_prospecto_exclude = undefined
}: TableSeguimientoCosteProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventacoorporativa,
    PermissionsEnum.api_change_preventacoorporativa
  ]);

  // Estado para modal de documentos
  const [open, setOpen] = useState(false);
  const [documentsArray, setDocumentsArray] = useState<any>({});

  // PRV-008: Estado para modal de solicitud de Edición
  const [openModalSolicitud, setOpenModalSolicitud] = useState(false);
  const [factibilidadSeleccionada, setFactibilidadSeleccionada] = useState<IFactibilidadCorporativo | null>(null);
  const [datosCliente, setDatosCliente] = useState<{ razon_social?: string; identificacion?: string } | null>(null);
  //
  const [rowSelection, setRowSelection]=useState({})
  ///* Hook
  const { columnsSeguimientoCoste } = useColumnsSeguimientoCoste({
    setOpen,
    setDocumentsArray
  });
  const navigate = useNavigate();

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const {
    filterObject,
    columnFilters, setColumnFilters
  } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  ///* Fetch
  const {
    isLoading,
    data: dataTrazoCorporativo,
    isRefetching
  } = useFetchReporteGeneralCorporativo(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      [estado_prospecto?"estado_prospecto":""]:[estado_prospecto?estado_prospecto:""],
      [estado_prospecto_exclude?"estado_prospecto_exclude":""]:[estado_prospecto_exclude?estado_prospecto_exclude:""],
    }
  );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IReporteVentaCorporativaParams>
            columns={columnsSeguimientoCoste}
            data={dataTrazoCorporativo?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataTrazoCorporativo?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            canEdit={hasPermission(PermissionsEnum.api_change_factibilidadcoorporativa)}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM + 50}
            enableEditing={true}
            //
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableSelectAll
            enableRowSelection
            pinLeftColumnIndexes={[0,1]}
            // Botón de revisar (ojito) - lleva a Solución Costeada para carga de documentos
            editIcon={<Visibility />}
            toolTipTitleEditIcon="Revisar"
            canEditByRowData={(value) => {
              const factibilidad = value.factibilidad_corporativa_data?.[0];
              return (
                !!factibilidad?.aceptado_factibilidad &&
                !!factibilidad?.preaprobado_inventario
              );
            }}
            onEdit={(value) => {
              const factibilidad = value.factibilidad_corporativa_data?.[0];
              if (factibilidad) {
                navigate(`${ROUTER_PATHS.ventasCorporativas.solucionCosteadaCorporativoNav}/${factibilidad.id_factibilidad_coorporativa}`);
              }
            }}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              // Obtener la primera factibilidad del prospecto (si existe)
              const factibilidad = value.factibilidad_corporativa_data?.[0];
              if (!factibilidad) return null;

              // PRV-008: Determinar si se puede solicitar Edición
              // Solo si est&aacute; aceptada, pre-aprobada por inventario y NO aprobada por supervisor
              const puedeEditar = factibilidad.aceptado_factibilidad &&
                factibilidad.preaprobado_inventario &&
                !factibilidad.aprobado_supervisor;

              return (
                <Grid container spacing={1}>
                  {/* PRV-008: Bot&oacute;n Solicitar Edición */}
                  {puedeEditar && (
                    <Grid item>
                      <Tooltip placement='top' title='Solicitar Edición'>
                        <IconButton
                          color="warning"
                          onClick={() => {
                            setFactibilidadSeleccionada(factibilidad);
                            // Guardar datos del cliente desde el prospecto (value)
                            setDatosCliente({
                              razon_social: value.razon_social || value.nombre_comercial || undefined,
                              identificacion: value.identificacion ?? undefined
                            });
                            setOpenModalSolicitud(true);
                          }}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                  <Grid item>
                    <Tooltip placement='top' title='Ver Trazabilidad'>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          navigate(`${ROUTER_PATHS.noc.trazabilidadFactibilidadCorporativoNav}/${factibilidad.id_factibilidad_coorporativa}?from=seguimiento-coste`);
                        }}
                      >
                        <Timeline />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }}
          />
        </Grid>
        <InfoCoordendas/>
      </Grid>

      {/* Modal para ver documentos */}
      <VerDocumentosHabilitantesContractuales
        open={open}
        setOpen={setOpen}
        documentsArray={documentsArray}
      />

      {/* PRV-008: Modal para solicitar Edición */}
      <ModalSolicitudEdicion
        open={openModalSolicitud}
        setOpen={setOpenModalSolicitud}
        factibilidad={factibilidadSeleccionada}
        datosCliente={datosCliente}
      />
    </>
  );
}
